import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/shopping.jpg";
import emotion from "../../Assets/Projects/it.jpg";
import editor from "../../Assets/Projects/streaming.png";
import chatify from "../../Assets/Projects/iptv.jpg";
import suicide from "../../Assets/Projects/swap.jpg";
import bitsOfCode from "../../Assets/Projects/cloud.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="IPTV DASHBOARD"
              description="Build template iptv web application with frontend & backend and system management , user , payment , vod , movies . video , live stream management ."
              // ghLink="https://github.com/soumyajit4419/Chatify"
              demoLink="https://ton.zapto.org/playlab/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Voip System"
              description="Build and Develop Voip system ip-phone , pbx server , cloud pbx and more.."
              // ghLink="https://github.com/soumyajit4419/Bits-0f-C0de"
              demoLink="#"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Streaming Service"
              description="Build Install Streaming Server Engine live stream vod stream"
              // ghLink="https://github.com/soumyajit4419/Editor.io"
              demoLink="#"              
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={false}
              title="Shopping Webapps"
              description="Build Shopping website template from php scripts."
              // ghLink="https://github.com/soumyajit4419/Plant_AI"
              demoLink="#"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="DeFi Swap Exchange"
              description="Build DeFi Swap token for erc20,bep20 amd more network ."
              // ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
              demoLink="https://smokingswap.vercel.app/" include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={emotion}
              isBlog={false}
              title="It Helpdesk & SUpport"
              description="Support Help It projrct Network project develop internet MPLS router config  design network and more..."
              // ghLink="https://github.com/soumyajit4419/Face_And_Emotion_Detection"
              demoLink="#"  Please include a demo link here 
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
